import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../store/actions';

export const useInitTranslations = (translations: Record<string, string>) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.setDefaultTranslationsAction(translations));
    }, [dispatch, translations]);
};
